import {takeLatest} from 'redux-saga/effects';

import {assignPubEditorSaga} from './AssignPubEditor/saga';
import {deleteAssignedPubEditorSaga} from './DeassignPubEditor/saga';
import {updateSinglePub} from './EditPub/saga';
import {getPubEditorsSaga} from './GetPubEditors/saga';
import {getSinglePubSaga} from './GetSinglePub/saga';
import {
  assignPubEditorACS,
  getPubEditorsACS,
  getSinglePubACS,
  unassignPubEditorACS,
  updateSinglePubACS,
} from './requests';

export function* SinglePubSaga() {
  yield takeLatest(getSinglePubACS.type, getSinglePubSaga);
  yield takeLatest(assignPubEditorACS.type, assignPubEditorSaga);
  yield takeLatest(updateSinglePubACS.type, updateSinglePub);
  yield takeLatest(unassignPubEditorACS.type, deleteAssignedPubEditorSaga);
  yield takeLatest(getPubEditorsACS.type, getPubEditorsSaga);
}
